import { cn } from "@/lib/utils";

export const Logo = ({ size = "md", withText = true, className }) => {
  const sizes = { sm: "w-8 h-8 text-sm", md: "w-10 h-10 text-base", lg: "w-14 h-14 text-xl" };
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="app-logo">
      <div className={cn(
        "rounded-2xl bg-gradient-to-br from-primary to-secondary text-white font-black flex items-center justify-center shadow-lg shadow-primary/20 shrink-0",
        sizes[size],
      )}>
        QC
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-extrabold text-slate-800 tracking-tight">Coach Quran</div>
          <div className="text-[10px] font-bold uppercase tracking-widest text-secondary">Mémorise le Coran</div>
        </div>
      )}
    </div>
  );
};
